import React from 'react';
import { SiteContent } from '../data/content';

interface SelectedWorkProps {
  content: SiteContent['selectedWork'];
}

export const SelectedWork: React.FC<SelectedWorkProps> = ({ content }) => {
  return (
    <section className="selected-work-section" id="work" aria-labelledby="work-title">
      <div className="container">
        <div className="section-head">
          <p className="eyebrow">{content.eyebrow}</p>
          <h2 id="work-title" className="section-title">
            {content.title}
          </h2>
          <p className="section-subtitle">{content.subtitle}</p>
        </div>

        <div className="chapters-stream">
          {content.chapters.map((chapter) => (
            <article key={chapter.id} className="chapter-entry">
              <div className="chapter-lead">
                <span className="chapter-tag">{chapter.chapter}</span>
                <h3 className="chapter-company">{chapter.company}</h3>
                <p className="chapter-role">{chapter.role}</p>
              </div>

              <div className="chapter-details">
                <p className="chapter-summary">{chapter.summary}</p>
                <ul className="chapter-bullets" aria-label="Key scope & achievements">
                  {chapter.bullets.map((bullet, idx) => (
                    <li key={idx}>{bullet}</li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
